import { grey } from '@mui/material/colors';

export const lightModeCrossPolColor = '#FF6F00';
export const darkModeCrossPolColor = '#3399FD';
export const lightModeTraceColor = 'rgb(54, 162, 235)';

export const getTickColor = (inLightMode: boolean) =>
  inLightMode ? undefined : '#ffffff';

export const getGridColor = (inLightMode: boolean) =>
  inLightMode ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.5)';

export const getDetectorNameColor = (inLightMode: boolean) =>
  inLightMode ? grey[800] : grey[300];

export const getMarkerColor = (index: number, inLightMode: boolean) =>
  inLightMode ? lightModeMarkerColors[index] : darkModeMarkerColors[index];

export const lightModeDragColor = grey[400];

export const lightModeBaselineColor = grey[600];
export const darkModeBaselineColor = 'lightgray';

export let darkModeMarkerColors = [
  'rgb(255, 255, 255)',
  'rgb(255,255,0)',
  'rgb(255,0,0)',
  'rgb(0,255,255)',
];

export let lightModeMarkerColors = [
  grey[700],
  lightModeCrossPolColor,
  'rgb(255,0,0)',
  '#0069c0',
];
